import { render } from "./PackingOrderBlock.vue?vue&type=template&id=89e858b6&scoped=true"
import script from "./PackingOrderBlock.vue?vue&type=script&lang=js"
export * from "./PackingOrderBlock.vue?vue&type=script&lang=js"

import "./PackingOrderBlock.vue?vue&type=style&index=0&id=89e858b6&lang=scss&scoped=true"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e858b6"]])

export default __exports__